/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import Header from '../../components/common/Header/Header';
import '../RegistrationSetup/Registrationsetup.scss';

class WhiteLabeling extends Component {
  constructor(props) {
    super(props);

    this.state = {
      whiteLabelingEdit: false,
    };
    this.WhiteLabelingEdit = this.WhiteLabelingEdit.bind(this);
  }
  WhiteLabelingEdit = () => {
    this.setState({ whiteLabelingEdit: true });
    //this.props.history.push( '/admin/white-labeling-edit' );
  };

  render() {
    const { whiteLabelingEdit } = this.state;
    const { t } = this.props;

    if (whiteLabelingEdit) {
      return <Navigate to="/admin/white-labeling-edit" push={true}></Navigate>;
    }

    return (
      <div>
        <Container fluid className="claims-details">
          <Header
            linkTo={'/admin/admin-dashboard'}
            header={t('admin.pages.branding.module')}
          />

          <Row className="Payment-details whitelist">
            <Col className="padding-0">
              <h3>Title & Logo</h3>
              <p>
                First step for theming which includes the title of the member
                portal and upload logos.
              </p>
            </Col>
            <Col className="setup-form">
              <div>
                <Form.Group controlId="formGroupTitle">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    plaintext
                    readOnly
                    defaultValue="A1M Health Insurance"
                  />
                </Form.Group>
              </div>
              <div>
                <Form.Group controlId="formGroupLogo">
                  <Form.Label>Logo</Form.Label>
                  <img
                    src={require('../../img/A1MLogo_new.png')}
                    id="tick-img"
                    alt="LogoImage"
                  />
                </Form.Group>
              </div>
            </Col>
          </Row>
          <Row className="Payment-details whitelist">
            <Col className="padding-0">
              <h3>Color Palette</h3>
              <p>
                The appearance of web portal and the mobile app across all
                devices.
              </p>
            </Col>
            <Col className="setup-form">
              <div className="colorplate-img">
                <img
                  src={require('../../img/colorplate.svg')}
                  id="color-img"
                  alt="ColorImage"
                />
                <p>Default</p>
              </div>
              <div>
                <Form.Group controlId="formGroupDark">
                  <Form.Label>Dark Mode </Form.Label>
                  <Form.Control plaintext readOnly defaultValue="Disabled" />
                </Form.Group>
              </div>
            </Col>
          </Row>
          <Row className="Payment-details whitelist">
            <Col className="padding-0">
              <h3>Fonts</h3>
              <p>
                The fonts of web portal and the mobile app across all devices.
              </p>
            </Col>
            <Col className="setup-form">
              <div>
                <Form.Group controlId="formGroupFontHead">
                  <Form.Label>Default fonts for Headings</Form.Label>
                  <Form.Control plaintext readOnly defaultValue="Open Sans" />
                </Form.Group>
              </div>
              <div>
                <Form.Group controlId="formGroupPara">
                  <Form.Label>
                    Default fonts for Paragraphs and other texts
                  </Form.Label>
                  <Form.Control plaintext readOnly defaultValue="Open Sans" />
                </Form.Group>
              </div>
            </Col>
          </Row>

          <Row className="Payment-details password-policy">
            <Col className="float-right text-right">
              <Button
                variant="primary"
                className="sav-btn"
                onClick={this.WhiteLabelingEdit}
              >
                Modify
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
export default withTranslation()(WhiteLabeling);
